import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../constants';
import { getToken } from '../../../services/tokenService';

export default function useEcheancier({ getAuthHeader, getAmount, isPaid: isPaid, fetchData }) {
  const [showEcheanceModal, setShowEcheanceModal] = useState(false);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [showRecuModal, setShowRecuModal] = useState(false);
  const [echeanceDate, setEcheanceDate] = useState('');
  const [scheduleItems, setScheduleItems] = useState([{ date: '', amount: 0 }]);
  const [selectedDoc, setSelectedDocEch] = useState(null);
  const [processing, setProcessing] = useState(false);

  const openEcheanceModal = (doc) => {
    setSelectedDocEch(doc);
    setEcheanceDate(doc?.prochaine_echeance?.date || '');
    setShowEcheanceModal(true);
  };

  const handleEcheance = async () => {
    if (!selectedDoc) return;
    setProcessing(true);
    try {
      await axios.post(`${API}/domium/subscribe/admin/${selectedDoc.reference}/update-echeance`,
        { date: echeanceDate, observations: '' }, { headers: getAuthHeader() });
      toast.success('Echeance mise a jour');
      setShowEcheanceModal(false); fetchData();
    } catch { toast.error('Erreur mise a jour'); }
    finally { setProcessing(false); }
  };

  const openScheduleModal = (doc) => {
    setSelectedDocEch(doc);
    const existing = doc?.echeancier_personnalise?.echeances || [];
    if (existing.length > 0) {
      setScheduleItems(existing.map(e => ({ date: e.date || '', amount: e.montant || 0 })));
    } else {
      const amt = getAmount(doc) / 2;
      setScheduleItems([{ date: '', amount: Math.round(amt) }, { date: '', amount: Math.round(amt) }]);
    }
    setShowScheduleModal(true);
  };

  const handleSchedule = async () => {
    if (!selectedDoc) return;
    setProcessing(true);
    try {
      await axios.post(`${API}/domium/subscribe/admin/${selectedDoc.reference}/create-echeancier`,
        { echeances: scheduleItems.map(s => ({ date: s.date, montant: s.amount })) },
        { headers: getAuthHeader() });
      toast.success('Echeancier cree');
      setShowScheduleModal(false); fetchData();
    } catch { toast.error('Erreur creation'); }
    finally { setProcessing(false); }
  };

  const handleDeleteEcheancier = async (doc) => {
    if (!doc?.reference) { toast.error('Reference manquante'); return; }
    const echeances = doc?.echeancier_personnalise?.echeances || [];
    const paidCount = echeances.filter(e => e.statut === 'paye').length;
    const msg = paidCount > 0
      ? `Attention: ${paidCount} echeance(s) deja payee(s). Supprimer cet echeancier ?`
      : 'Supprimer cet echeancier ?';
    if (!window.confirm(msg)) return;
    try {
      const token = getToken();
      await axios.delete(`${API}/domium/subscribe/admin/${doc.reference}/echeancier`,
        { headers: { Authorization: `Bearer ${token}` } });
      toast.success(`Echeancier supprime (${echeances.length} echeances)`);
      fetchData(true);
    } catch (error) { toast.error(error.response?.data?.detail || 'Erreur lors de la suppression'); }
  };

  const handleResetEcheancier = async (doc) => {
    if (!doc?.reference) { toast.error('Reference manquante'); return; }
    const echeances = doc?.echeancier_personnalise?.echeances || [];
    const paidCount = echeances.filter(e => e.statut === 'paye').length;
    if (paidCount === 0) { toast.info('Aucune echeance payee a reinitialiser'); return; }
    if (!window.confirm(`Reinitialiser ${paidCount} echeance(s) payee(s) ?`)) return;
    try {
      const token = getToken();
      await axios.put(`${API}/domium/subscribe/admin/${doc.reference}/reset-echeancier`,
        {}, { headers: { Authorization: `Bearer ${token}` } });
      toast.success(`Echeancier reinitialise (${echeances.length} echeances)`);
      fetchData(true);
    } catch (error) { toast.error(error.response?.data?.detail || 'Erreur lors de la reinitialisation'); }
  };

  return {
    showEcheanceModal, setShowEcheanceModal, showScheduleModal, setShowScheduleModal,
    showRecuModal, setShowRecuModal, echeanceDate, setEcheanceDate,
    scheduleItems, setScheduleItems,
    openEcheanceModal, handleEcheance, openScheduleModal, handleSchedule,
    handleDeleteEcheancier, handleResetEcheancier,
    echSelectedDoc: selectedDoc, echProcessing: processing, setProcessing,
  };
}
